<template>
  <div class="container">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="box">
          <img class="image logo" src="../assets/logo1.png" alt="Me Want Food"> 
          <div class="notification is-danger" v-if="flash">{{flash}}</div>
          <form v-on:submit.prevent="submit">
            <div class="field">
              <label class="label">First Name</label>
              <div class="control">
                <input v-model="form.firstName" ref="firstName" class="input" type="text" placeholder="First Name">
              </div>
            </div>
            <div class="field">
              <label class="label">Last Name</label>
              <div class="control">
                <input v-model="form.lastName" class="input" type="text" placeholder="Last Name">
              </div>
            </div>
            <div class="field">
              <label class="label">Email</label>
              <div class="control has-icons-left">
                <input v-model="form.email" ref="email" class="input" type="email" placeholder="Email">
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">Password</label>
              <div class="control has-icons-left">
                <input v-model="form.password" class="input" type="password" placeholder="Password">
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
            </div>
            <div class="field is-grouped">
              <div class="control">
                <button class="button is-success" type="submit">
                  Register
                </button>
              </div>
              <div class="control">
                <button class="button is-text" type="button" @click="cancel">
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register } from '../utils/auth';

export default {
  name: 'login',
  data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
      },
      flash: null,
    };
  },
  mounted() {
    this.$nextTick(() => this.$refs.firstName.focus());
  },
  methods: {
    clear() {
      this.form.firstName = null;
      this.form.lastName = null;
      this.form.email = null;
      this.form.password = null;
      this.flash = null;
    },
    submit() {
      const form = {
        firstName: this.form.firstName.slice(0),
        lastName: this.form.lastName.slice(0),
        username: this.form.email.slice(0),
        password: this.form.password.slice(0),
      };

      register(form).then(() => {
        this.clear();
        this.$router.push({ name: 'browse' });
      })
      .catch((error) => {
        this.flash = error.message;
      });
    },
    cancel() {
      this.clear();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style lang="sass" scoped>
.logo
  display: block
  margin-left: auto
  margin-right: auto
  padding-bottom: 2.5rem
</style>



// WEBPACK FOOTER //
// src/components/Register.vue